<template>
  <div class="portal">
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <h2 class="mb-3">آزمون ها</h2>
        <v-card class="text-center pa-4">
          <div class="pa-3 d-flex align-center">
            <div class="text-h6 flex-fill ml-2 text-right font-weight-bold">
              گزارش آزمون های پورتال
            </div>
            <v-btn depressed color="success" :disabled="loading">
              <download-csv
                :data="answerSheets"
                name="آزمون های پورتال.csv"
                :labels="csvlabels"
                :fields="csvfields"
                class="d-flex align-center"
              >
                <v-icon class="ml-2 text-body-2"
                  >mdi-content-save-settings-outline</v-icon
                >
                <small>ذخیره گزارش</small>
              </download-csv>
            </v-btn>
          </div>
          <div class="pa-3">
            <div v-if="portal">
              جناب آقای / سرکار خانم
              <strong>{{ portal.user.firstname }}</strong>
              <strong> {{ portal.user.lastname }}</strong>
              رابط محترم پورتال
              <strong>{{ portal.name }}</strong>
              ؛ آزمون های آخر پورتال شما به شرح زیر می باشد:
            </div>
            <div class="d-flex align-center mt-6">
              <v-alert outlined type="info" class="mb-0 ml-2 pa-2 flex-fill">
                به صورت پیش فرض 50 آزمون آخر پورتال شما نمایش داده می شود - صفحه
                {{ skip + 1 }}
              </v-alert>
              <v-btn
                :loading="loading"
                depressed
                color="primary"
                @click="updateData"
              >
                گزارش 50 آزمون بعدی
              </v-btn>
            </div>

            <v-data-table
              dense
              :items="answerSheets"
              :headers="headers"
              :items-per-page="50"
              :loading="loading"
              item-key="_id"
              hide-default-footer
              loading-text="در حال ساخت گزارش ..."
              class="mt-5 px-3 text-no-wrap"
            >
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "students-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      info: true,
      loading: true,
      error: null,
      headers: [
        { text: "استفادکننده", align: "center", value: "user" },
        { text: "نام کتاب", align: "center", value: "book" },
        { text: "پایه", align: "center", value: "grade" },
        {
          text: "نمره پایانی (%)",
          align: "center",
          value: "totalScore"
        },
        { text: "تمرکز (%)", align: "center", value: "focusScore" },
        {
          text: "استنباط (%)",
          align: "center",
          value: "inferenceScore"
        },
        {
          text: "تفسیر (%)",
          align: "center",
          value: "interpretationScore"
        },
        {
          text: "ارزیابی (%)",
          align: "center",
          value: "assessmentScore"
        }
      ],
      portal: null,
      answerSheets: [],
      csvfields: [
        "user",
        "book",
        "grade",
        "totalScore",
        "focusScore",
        "inferenceScore",
        "interpretationScore",
        "assessmentScore"
      ],
      csvlabels: {
        user: "نام و نام خانوادگی",
        book: "نام کتاب",
        grade: "پایه",
        totalScore: "نمره پایانی (%)",
        focusScore: "تمرکز (%)",
        inferenceScore: "استنباط (%)",
        interpretationScore: "تفسیر (%)",
        assessmentScore: "ارزیابی (%)"
      },
      skip: 0
    };
  },
  created() {
    this.handleGetDiscountCodes();
  },
  methods: {
    handleGetDiscountCodes() {
      this.loading = true;
      this.$api
        .post("/schoolResaultByPortal", {
          skip: this.skip
        })
        .then((res) => {
          this.portal = res.data.portal;
          this.answerSheets = res.data.answerSheets;
          this.loading = false;
        });
    },
    updateData() {
      this.answerSheets = [];
      this.skip = this.skip + 1;
      this.handleGetDiscountCodes();
    }
  }
};
</script>
